import React, {useEffect,useState} from 'react';
import fonts from '../../../fonts/THSarabunNew.ttf';
import fonts_bold from '../../../fonts/THSarabunNew Bold.ttf';
import { Page, Text, View, Document, StyleSheet,Image } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';
import { Font } from '@react-pdf/renderer'
import img from '../../../images/logo.png'
import Axios from 'axios';
import Constants from '../../../config/constants';
import objDefault from '../../../models/dischargePdfModel'
import moment from "moment";
import {Table,DataTableCell,TableHeader,TableCell,TableBody} from '@david.kucsai/react-pdf-table'
import {staff} from "../../../config/staff"

const eyes = [
    {key: 4, text: 'Spontaneous (4)', value: 4},
    {key: 3, text: 'To sound (3)', value: 3},
    {key: 2, text: 'To pressure (2)', value: 2},
    {key: 1, text: 'None (1)', value: 1},
    {key: 0, text: 'Non-testable (NT) ', value: 1}
]
const verbal = [
    {key: 5, text: 'Orientated (5)', value: 5},
    {key: 4, text: 'Confused (4)', value: 4},
    {key: 3, text: 'Words (3)', value: 3},
    {key: 2, text: 'Sounds (2)', value: 2},
    {key: 1, text: 'None (1)', value: 1},
    {key: 0, text: 'Non-testable (NT)', value: '1'}
]
const best = [
    {key: 6, text: 'Obey commands (6)', value: 6},
    {key: 5, text: 'Localizing (5)', value: 5},
    {key: 4, text: 'Normal flexion (4)', value: 4},
    {key: 3, text: 'Abnormal flexion (3)', value: 3},
    {key: 2, text: 'Extension (2)', value: 2},
    {key: 1, text: 'None (1)', value: 1},
    {key: 0, text: 'Non-testable (NT)', value: 1}
]

const dcStatus = [
    {key: '1', text: 'COMPLETE RECOVERY', value: '1'},
    {key: '2', text: 'IMPROVED', value: '2'},
    {key: '3', text: 'NOT IMPROVED', value: '3'},
    {key: '4', text: 'DEATH ,NO AUTOPSY', value: '4'},
    {key: '5', text: 'DEATH ,AUTOPSY', value: '5'}
]
const dcType = [
    {key: '1', text: 'WITH APPOVAL', value: '1'},
    {key: '2', text: 'AGAINST ADVICE', value: '2'},
    {key: '3', text: 'BY ESCAPE', value: '3'},
    {key: '4', text: 'BY TRANSFER', value: '4'},
    {key: '5', text: 'OTHER', value: '5'},
    {key: '6', text: 'DEATH', value: '6'}
]



Font.register({
    family: 'th',
    fonts: [
        {
            src: fonts
        },
        {
            src: fonts_bold,
            fontWeight: 'bold'
        },

    ]
})
const styles = StyleSheet.create({
    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        fontFamily: 'th'
    },

    tableRow: {
        margin: "auto",
        flexDirection: "row",
        fontFamily: 'th',

    },
    table1: {
        display: "table",
        width: "auto",
        borderRightWidth: 0,
        borderBottomWidth: 0,
        fontFamily: 'th'
    },

    tableRow1: {

        flexDirection: "row",
        fontFamily: 'th'

    },
    tableCol: {
        width: "25%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,

        marginTop:0
    },
    tableCell: {
        margin:0,
        marginTop:0,
        paddingLeft:5,
        fontSize: 16,
        fontWeight:'bold',
        textAlign:'center'
    },

    tableCol3: {
        width: "50%",

        borderLeftWidth: 0,
        borderTopWidth: 0,

    },
    tableCol3_sub: {
        width: "100%",

        borderLeftWidth: 0,
        borderTopWidth: 0,

    },
    tableCol3_head:{
        width: "35%",
        borderLeftWidth: 0,
        borderTopWidth: 0,
    },
    tableCol3_remark:{
        width: "65%",

        borderTopWidth: 0,
        textAlign:'left',

    },
    tableCell3: {
        margin:0,
        marginTop:0,
        paddingLeft:5,
        fontSize: 12,
        fontWeight:'bold',
        textAlign:'left'
    },

    tableCell2: {
        margin:0,
        marginTop:0,
        paddingLeft:20,
        fontSize: 12,
        paddingRight:30
    },
    tableCellData: {
        margin:0,
        marginTop:2,
        paddingLeft:5,
        fontSize: 15,
       textAlign:'center'
    },

    table2: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        marginTop:20
    },


    tableTriss: {
        display: "table",
        borderStyle: "solid",
        borderWidth: 1,
        marginBottom:20,
        width : 600
    },

    tableRow2: {
        margin: "auto",
        flexDirection: "row",
    },
    tableCol2: {
        width: "33.33%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
    },

    body: {
        paddingTop: 0,
        paddingBottom: 0,
        paddingHorizontal: 0,
        fontFamily: 'th',

    },
    textHead: {
        marginTop: 0,
        marginLeft :15,
        marginRight:20,
        fontSize: 14,
        fontWeight: 600,
        textAlign: 'justify',
        fontFamily: 'th',
        fontweight:'bold'
    },
    textContrainer: {
        marginTop: 0,
        marginLeft :18,
        marginRight:20,
        fontSize: 12,
        fontWeight: 600,
        textAlign: 'justify',
        fontFamily: 'th'
    },
    textSubContrainer: {
        marginTop: 0,
        marginLeft :50,
        marginRight:20,
        fontSize: 14,
        fontWeight: 600,
        textAlign: 'justify',
        fontFamily: 'th'
    },
    textSubSecondary: {
        marginTop: 0,
        marginLeft :60,
        marginRight:20,
        fontSize: 11,
        fontWeight: 600,
        textAlign: 'justify',
        fontFamily: 'th'
    },
    tableCol_20 : {
        border: 1
    }
});

// Create Document Component
const Pdf = () => {
    const [input, setInput] = useState({
        ...objDefault
    });
    const [inputAis,setAis] = useState([])


    useEffect(  ()  => {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const id = params.get('discharge_id')
        setTimeout(
            () => getDischargeById(id),
            1000
        );
    }, [input]);

    const getDischargeById = async  (id) => {
        try {
            let dc_data =  await  Axios.get('http://'+Constants.url+':'+Constants.port+'/v1/snr/discharge?discharge_id=' +id,{
                headers: {
                    Authorization: Constants.headerAuthorization,
                    'Content-Type': 'application/json'
                }
            })

            let response   = dc_data.data.data[0]
            let ais_data = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/aiscode?admission_id=' + response.admission_id,{
                headers: {
                    Authorization: Constants.headerAuthorization,
                    'Content-Type': 'application/json'
                }
            })
            let ais_response = ais_data.data.data
            setInput((prevInput) => ({
                ...prevInput,
                name: response.name,
                surname: response.surname,
                address: response.address,
                citizen_id: response.citizen_id,
                gender: response.gender =='M'?'ชาย':'หญิง',
                id : response.id,
                admission_date: !!response.admission_date? moment(response.admission_date).format("DD-MM-YYYY"):null,
                admission_date_age : response.admission_date,
                discharge_date:!!response.discharge_date? moment(response.discharge_date).format("DD-MM-YYYY"):null,
                discharge_status:!!response.discharge_status?dcStatus.find(item => item.key == response.discharge_status).text:'',
                discharge_type:!!response.discharge_type?dcType.find(item => item.key == response.discharge_type).text:'',
                history:response.history,
                chief_complaint:response.chief_complaint,
                hr:response.hr,
                pr:response.rr,
                bp_s:response.bp_s,
                bp_d:response.bp_d,
                bt:response.bt,
                sat:response.sat,
                other:response.other,
                gcs_e:response.gcs_e?eyes.find(item => item.key === response.gcs_e).text:'',
                gcs_v:response.gcs_v?verbal.find(item => item.key === response.gcs_v).text:'',
                gcs_m:response.gcs_m?best.find(item => item.key === response.gcs_m).text:'',
                gsc_all :response.gsc_all,
                inv_eFAST:response.inv_eFAST,
                inv_p_cxr:response.inv_p_cxr,
                inv_other:response.inv_other,
                management:response.management,
                operation:response.operation,
                findings:response.findings,
                principal_diagnosis:response.principal_diagnosis,
                other_problems:response.other_problems,
                hosital_course:response.hosital_course,
                complication:response.complication,
                home_medications:response.home_medications,
                appointment:response.appointment,
                iss_head:response.iss_head,
                iss_chest:response.iss_chest,
                iss_external:response.iss_external,
                iss_face:response.iss_face,
                iss_abdomen:response.iss_abdomen,
                iss_extremity:response.iss_extremity,
                iss_rr:response.iss_rr,
                mechanism_injury:response.mechanism_injury=='p'?'Penetrating':'Blunt',
                admission_id : response.admission_id,
                visit_id: response.patient_visit_id,
                patient_id: response.patient_id,
                hn:response.hn,
                an:response.an,
                iss:response.iss,
                ward:response.ward,
                staff_name: response.staff_id ? staff.find(item => item.key == response.staff_id).text : '',
                resident_name : response.resident_name,
                division :response.division,
                record_name :response.record_name,
                recode_code : response.recode_code,
                record_datetime : response.record_datetime,
                birth_date : response.birth_date,
                age : response.age,
                stay: response.stay,
                rts:response.rts,
                triss:response.triss,
                ais_1 : ais_response[0]?ais_response[0]['injury_description']:'',
                ais_2 : ais_response[1]?ais_response[1]['injury_description']:'',
                ais_3 : ais_response[2]?ais_response[2]['injury_description']:'',
                ais_4 : ais_response[3]?ais_response[3]['injury_description']:'',
                ais_5 : ais_response[4]?ais_response[4]['injury_description']:'',
                ais_6 : ais_response[5]?ais_response[5]['injury_description']:'',
                ais_7 : ais_response[6]?ais_response[6]['injury_description']:'',
                ais_8 : ais_response[7]?ais_response[7]['injury_description']:'',
                ais_9 : ais_response[8]?ais_response[8]['injury_description']:'',
                ais_10 : ais_response[9]?ais_response[9]['injury_description']:'',
                ais_11 : ais_response[10]?ais_response[10]['injury_description']:'',
                ais_12 : ais_response[11]?ais_response[11]['injury_description']:'',
                ais_13 : ais_response[12]?ais_response[12]['injury_description']:'',
                ais_14 : ais_response[13]?ais_response[13]['injury_description']:'',
                ais_15 : ais_response[14]?ais_response[14]['injury_description']:'',
                ais_16 : ais_response[15]?ais_response[15]['injury_description']:'',
                ais_17 : ais_response[16]?ais_response[16]['injury_description']:'',
                ais_18 : ais_response[17]?ais_response[17]['injury_description']:'',
                ais_19 : ais_response[18]?ais_response[18]['injury_description']:'',
                ais_20 : ais_response[19]?ais_response[19]['injury_description']:'',
                ais_21 : ais_response[20]?ais_response[20]['injury_description']:'',
                ais_22 : ais_response[21]?ais_response[21]['injury_description']:''




            }))

        }catch (e) {
            console.log(e);
        }

    }
    return (
        <PDFViewer style={{width: '100%', height: '100vh',}}>
            <Document>
                <Page style={styles.body}>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableCol}>

                                <Image style={{width:'55',marginLeft:'45',marginTop:'5'}}

                                       src={img}
                                />

                            </View>
                            <View style={styles.tableCol}>
                                <Text  style={styles.tableCell}>Discharge summary{"\n"}</Text>
                                <Text style={styles.tableCellData}> Deparment of Surgery{"\n"}</Text>
                                <Text style={{fontSize:'10',textAlign:'center'}}>Faculty of Medicine , Khon Kaen University</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={{fontSize:12,fontWeight:'bold'}}>&nbsp;&nbsp;ผู้บาดเจ็บ {input.name} {input.surname}{"\n"}</Text>
                                <Text style={{fontSize:12,fontWeight:'bold'}}>&nbsp;&nbsp;HN {input.hn}&nbsp;&nbsp;&nbsp;&nbsp;AN {input.an}{"\n"}</Text>
                                <Text style={{fontSize:12,fontWeight:'bold'}}>&nbsp;&nbsp;เพศ {input.gender} &nbsp;&nbsp;&nbsp;&nbsp;อายุ : {input.age} ปี{"\n"}</Text>
                                <Text style={{fontSize:12,fontWeight:'bold'}}>&nbsp;&nbsp;Length of stay : {input.stay} วัน</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={{fontSize:12,fontWeight:'bold',marginLeft:5}}>
                                    Ward : {input.ward}{"\n"}
                                    Staff : {input.staff_name}{"\n"}
                                    Resident : {input.resident_name}{"\n"}
                                    Division : {input.division}
                                </Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.table1}>
                        <View style={styles.tableRow1}>

                            <View style={styles.tableCol3}>
                                <Text style={styles.textSubContrainer}>
                                    Admission date : <Text  style={{fontSize:14,fontWeight:'normal'}}>{input.admission_date}</Text>

                                </Text>

                            </View>
                            <View style={styles.tableCol3_sub}>
                                <Text style={styles.textSubContrainer}>
                                    Discharge date : <Text  style={{fontSize:14,fontWeight:'normal'}}>{input.discharge_date}</Text>
                                </Text>
                            </View>
                        </View>

                    </View>

                    <View
                        style={{
                            borderBottomColor: 'black',
                            borderBottomWidth: 1,
                            borderStyle: 'dotted',
                            borderRadius: 1,
                        }}
                    />
                    <Text style={styles.textHead}>
                        Chief complaint : <Text  style={{fontSize:14,fontWeight:'normal'}}>{input.chief_complaint}</Text>
                    </Text>
                    <Text style={styles.textHead}>
                        History : <Text  style={{fontSize:14,fontWeight:'normal'}}>{input.history}</Text>
                    </Text>
                    <Text style={styles.textHead}>
                        Physical examinations
                    </Text>
                    <Text style={styles.textSubContrainer}>
                        HR :<Text  style={{fontSize:14,fontWeight:'normal',marginLeft:30}}> {input.hr}/min&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
                        RR :<Text  style={{fontSize:14,fontWeight:'normal',paddingRight:30}}> {input.pr}/min&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
                        BP : <Text  style={{fontSize:14,fontWeight:'normal',paddingRight:30}}> {input.bp_s}/{input.bp_d} mm.Hg.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
                        BT : <Text  style={{fontSize:14,fontWeight:'normal',paddingRight:30}}> {input.bt} c.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
                        Sat : <Text  style={{fontSize:14,fontWeight:'normal',paddingRight:30}}> {input.sat} %&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
                    </Text>
                    <Text style={styles.textSubContrainer}>
                        <Text  style={{fontSize:14,fontWeight:'normal'}}>{input.other}</Text>
                    </Text>
                    <Text style={styles.textContrainer}>
                        Eye opening (E) : <Text style={{
                        fontSize: 12,
                        fontWeight: 'normal'
                    }}>{input.gcs_e}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
                        Verbal response (V) : <Text style={{
                        fontSize: 12,
                        fontWeight: 'normal'
                    }}>{input.gcs_v}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
                        Motor response (M) : <Text style={{
                        fontSize: 12,
                        fontWeight: 'normal'
                    }}>{input.gcs_m}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>

                    </Text>
                    <View
                        style={{
                            borderBottomColor: 'black',
                            borderBottomWidth: 1,
                            borderStyle: 'dotted',
                            borderRadius: 1,
                            marginTop: 5
                        }}
                    />
                    <Text style={styles.textHead}>
                        Investigations
                    </Text>
                    <View style={styles.table1}>
                        <View style={styles.tableRow1}>

                            <View style={styles.tableCol3_head}>
                                <Text style={styles.textSubContrainer}>
                                    eFAST : <Text  style={{fontSize:14,fontWeight:'normal'}}>{input.inv_eFAST}</Text>
                                </Text>

                            </View>
                            <View style={styles.tableCol3_remark}>
                                <Text style={styles.textSubContrainer}>
                                    P-CXR : <Text  style={{fontSize:14,fontWeight:'normal'}}>{input.inv_p_cxr}</Text>
                                </Text>
                            </View>
                        </View>
                        <View style={styles.tableRow1}>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textSubContrainer}>
                                    Others : <Text  style={{fontSize:14,fontWeight:'normal'}}>{input.inv_other}</Text>
                                </Text>
                            </View>

                        </View>


                    </View>

                    <View
                        style={{
                            borderBottomColor: 'black',
                            borderBottomWidth: 1,
                            borderStyle: 'dotted',
                            borderRadius: 1,
                            marginTop: 5
                        }}
                    />
                    <Text style={styles.textHead}>
                        Management :  <Text  style={{fontSize:14,fontWeight:'normal'}}>{input.management?input.management:'-'}</Text>
                    </Text>
                    <Text style={styles.textSubContrainer}>
                        Operation :  <Text  style={{fontSize:14,fontWeight:'normal'}}>{input.operation?input.operation:'-'}</Text>
                    </Text>
                    <Text style={styles.textSubContrainer}>
                        Findings :  <Text  style={{fontSize:14,fontWeight:'normal'}}>{input.findings?input.findings:'-'}</Text>
                    </Text>
                    <View
                        style={{
                            borderBottomColor: 'black',
                            borderBottomWidth: 1,
                            borderStyle: 'dotted',
                            borderRadius: 1,
                            marginTop: 5
                        }}
                    />
                    <Text style={styles.textHead}>
                        Diagnosis
                    </Text>
                    <Text style={styles.textSubContrainer}>
                        Admission diagnosis :  <Text  style={{fontSize:14,fontWeight:'normal'}}>{input.principal_diagnosis?input.principal_diagnosis:'-'}</Text>
                    </Text>
                    <Text style={styles.textSubContrainer}>
                        Other diagnosis :  <Text  style={{fontSize:14,fontWeight:'normal'}}>{input.other_problems?input.other_problems:'-'}</Text>
                    </Text>

                    <View
                        style={{
                            borderBottomColor: 'black',
                            borderBottomWidth: 1,
                            borderStyle: 'dotted',
                            borderRadius: 1,
                            marginTop: 5
                        }}
                    />
                    <Text style={styles.textHead}>
                        Hospital course : <Text  style={{fontSize:14,fontWeight:'normal'}}>{input.hosital_course?input.hosital_course:'-'}</Text>
                    </Text>
                    <Text style={styles.textHead}>
                        Complication : <Text  style={{fontSize:14,fontWeight:'normal'}}>{input.complication?input.complication:'-'}</Text>
                    </Text>

                    <View style={styles.table1}>
                        <View style={styles.tableRow1}>

                            <View style={styles.tableCol3}>
                                <Text style={styles.textHead}>
                                    Discharge status : <Text  style={{fontSize:14,fontWeight:'normal'}}>{input.discharge_status}</Text>

                                </Text>

                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textHead}>
                                    Type : <Text  style={{fontSize:14,fontWeight:'normal'}}>{input.discharge_type}</Text>
                                </Text>
                            </View>
                        </View>



                    </View>

                    <Text style={styles.textHead}>
                        Home medications : <Text  style={{fontSize:14,fontWeight:'normal'}}>{input.home_medications}</Text>
                    </Text>
                    <Text style={styles.textHead}>
                        Appointment : <Text  style={{fontSize:14,fontWeight:'normal'}}>{input.appointment}</Text>
                    </Text>

                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableCol_100}>
                                <Text>
                                    Trauma and Injury Severity Score (TRISS) Calculator
                                </Text>
                            </View>
                        </View>
                    </View>
                    {
                        input.ais_1 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                          &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_1}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }
                    {
                        input.ais_2 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                            &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_2}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }
                    {
                        input.ais_3 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                            &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_3}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }
                    {
                        input.ais_4 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                            &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_4}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }
                    {
                        input.ais_5 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                            &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_5}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }
                    {
                        input.ais_6 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                            &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_6}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }
                    {
                        input.ais_7 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                            &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_7}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }
                    {
                        input.ais_8 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                            &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_8}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }
                    {
                        input.ais_9 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                            &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_9}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }
                    {
                        input.ais_10 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                            &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_10}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }
                    {
                        input.ais_11 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                            &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_11}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }
                    {
                        input.ais_12 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                            &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_12}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }
                    {
                        input.ais_13 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                            &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_13}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }
                    {
                        input.ais_14 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                            &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_14}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }
                    {
                        input.ais_15 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                            &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_15}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }
                    {
                        input.ais_16 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                            &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_16}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }
                    {
                        input.ais_17 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                            &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_17}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }
                    {
                        input.ais_18 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                            &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_18}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }
                    {
                        input.ais_19 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                            &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_19}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }
                    {
                        input.ais_20 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                            &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_20}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }
                    {
                        input.ais_21 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                            &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_21}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }
                    {
                        input.ais_22 ?
                            <View style={styles.table}>
                                <View >
                                    <View >
                                        <Text>
                                            &nbsp;&nbsp;&nbsp;  <Text  style={{fontSize:14,fontWeight:'normal'}}>- {input.ais_22}</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>:null
                    }


                    <Table
                        data={[
                            {   Head: "Revised Trauma Score",
                                SBP: "SBP : "+input.bp_s,
                                RR: "RR : "+input.pr,
                                GCS: "GCS : "+input.gsc_all,
                                RTS: "RTS : "+input.rts
                            },
                            {   Head: "TRISS",
                                SBP: "Mechanism of injury : "+input.mechanism_injury,
                                RR: "AGE : "+input.age+" Year",
                                GCS: "Probability of survival ",
                                RTS: input.triss+"%"
                            }
                        ]}
                    >
                        <TableHeader>

                            <TableCell style={{paddingLeft:10}}>
                                Injury Severity Score
                            </TableCell>
                            <TableCell style={{paddingLeft:10}}>
                                ISS
                            </TableCell>
                            <TableCell style={{paddingLeft:10}}>
                                {input.iss}
                            </TableCell>

                        </TableHeader>
                        <TableBody>
                            <DataTableCell style={{paddingLeft:10}} getContent={(r) => r.Head}/>
                            <DataTableCell style={{paddingLeft:10}} getContent={(r) => r.SBP}/>
                            <DataTableCell style={{paddingLeft:10}} getContent={(r) => r.RR}/>
                            <DataTableCell style={{paddingLeft:10}} getContent={(r) => r.GCS}/>
                            <DataTableCell style={{paddingLeft:10}} getContent={(r) => r.RTS}/>
                        </TableBody>

                    </Table>


                    <View style={styles.table2}>
                        <View style={styles.tableRow2}>
                            <View style={styles.tableCol2}>
                                <Text style={styles.tableCell2}>
                                    <Text style={{fontSize:12,fontWeight:'bold'}}>&nbsp;&nbsp;ผู้บาดเจ็บ {input.name} {input.surname}{"\n"}</Text>
                                    <Text style={{fontSize:12,fontWeight:'bold'}}>&nbsp;&nbsp;HN {input.hn}&nbsp;&nbsp;&nbsp;&nbsp;AN {input.an}{"\n"}</Text>
                                    <Text style={{fontSize:12,fontWeight:'bold'}}>&nbsp;&nbsp;เพศ {input.gender} &nbsp;&nbsp;&nbsp;&nbsp;อายุ : {input.age}{"\n"}</Text>

                                </Text>
                            </View>
                            <View style={styles.tableCol2}>
                                <Text  style={styles.tableCell2}>
                                    <Text style={{fontSize:12,fontWeight:'bold'}}>&nbsp;&nbsp;ผู้บันทึก {input.record_name}{"\n"}</Text>
                                    <Text style={{fontSize:12,fontWeight:'bold'}}>&nbsp;&nbsp;{input.recode_code}{"\n"}</Text>
                                    <Text style={{fontSize:12,fontWeight:'bold'}}>&nbsp;&nbsp;วันที่ {moment(input.record_datetime).format("DD-MM-YYYY HH:mm")} &nbsp;&nbsp;&nbsp;&nbsp;{"\n"}</Text>
                                </Text>
                            </View>
                            <View style={styles.tableCol2}>
                                <Text style={styles.tableCell2}>
                                    {"\n"}
                                    {"\n"}
                                    <Text style={{fontSize:12,fontWeight:'bold'}}> Sign : ...........................................................</Text>
                                </Text>
                            </View>

                        </View>
                    </View>

                </Page>
            </Document>
        </PDFViewer>
    )
}

export default Pdf;
